(function () {
    'use strict';

    angular
        .module('salesflare')
        .constant('config', {
            env: 'staging',
            mode: '',
            apiUrl: 'https://stagingapi.salesflare.com/',
            appUrl: 'https://staging.salesflare.com',
            notificationsUrl: 'https://pubsub-staging.salesflare.com:443',
            segment: {
                key: 'wsOWfdMCSewOj4qTYzQ7v4CuvWxBoHjf'
            },
            growsumo: {
                key: 'pk_TWoBWquDGJdZM1DDjTkzeomcp9qd5GzV'
            },
            refiner: {
                key: '38d29720-dc72-11ea-8588-91da2dac4ccb'
            },
            gcm: 128469695999,
            debugInfoEnabled: false,
            stripe: {
                key: 'pk_test_dQe0SoojMpwj2oxWhxiSW2vR',
                plans: {
                    monthly_GROWTH_USD: 'price_1RNvyxD7dHLLR45xmbNeq4i8',
                    monthly_GROWTH_EUR: 'price_1RNw4gD7dHLLR45x5Sadi5Wh',
                    annually_GROWTH_USD: 'price_1HuaUID7dHLLR45xK24aLIuD',
                    annually_GROWTH_EUR: 'price_1HuaUID7dHLLR45xlYxiM4sX',
                    monthly_PRO_USD: 'price_1RNw67D7dHLLR45xpxT8Brw5',
                    monthly_PRO_EUR: 'price_1RNw6YD7dHLLR45xeiSh8pSk',
                    annually_PRO_USD: 'annually_PRO_USD',
                    annually_PRO_EUR: 'annually_PRO_EUR'
                }
            },
            intercom: {
                appId: 'llin3h2f',
                horizontal_padding: 110,
                alignment: 'right'
            },
            zapier: {
                clientId: 'iqBeMJF5oFzkEFilfacD4Evy7oexnNneVQGNQfR7'
            },
            ycbm: {
                videoCallUrl: 'https://salesflare-video-call.youcanbook.me?noframe=true&skipHeaderFooter=true',
                phoneCallUrl: 'https://salesflare-quick-call.youcanbook.me?noframe=true&skipHeaderFooter=true'
            },
            sentry: {
                enabled: true
            },
            tracking: {
                baseUnsubscribeUrl: 'https://stagingapi.salesflare.com/optout',
                imgUrl: 'https://stagingpixel.salesfla.re/img/',
                oldImgUrl: 'https://stagingapi.salesflare.com/img/'
            },
            linkedIn: {
                redirectUrl: 'https://stagingapi.salesflare.com/datasources/connect?type=linkedin', // When changing this, it also needs to be changed in the LinkedIn developer console and the server
                oauthUrl: 'https://www.linkedin.com/oauth/v2/authorization',
                clientId: '78tn3o7n5ayrb3'
            },
            logoApi: 'https://europe-west1-sunlit-tea-790.cloudfunctions.net/logo-api-staging/'
        });
})();
